const homeVueContent = `<template>
  <div class="home">
    Home component
  </div>
</template>

<script>
export default {
  name: "Home",
};
<\/script>
`;

export default homeVueContent;
